'use client';

import clsx from 'clsx';

import { FC } from 'react';

import { FasBars, FasXmark } from '@virginmediao2/momentum-icons/icons/fas';

import { Icon } from '@/components/momentum/components/icon';

import styles from './side-navigation-trigger.module.scss';

export const SideNavigationTrigger: FC = () => {
  return (
    <button
      className={clsx(
        styles['mega-menu-side-navigation-trigger'],
        'toggle-icon-button'
      )}
      aria-controls={'mega-menu-side-navigation'}
      data-sidenav-trigger
    >
      <span className='opened-icon'>
        <Icon icon={FasXmark} />{' '}
      </span>
      <span className='closed-icon'>
        <Icon icon={FasBars} />
      </span>
    </button>
  );
};
